import {FC} from 'react'
import {Field, ErrorMessage, useFormikContext, getIn} from 'formik'


const Step1: FC = () => {
    const formikProps = useFormikContext()
    const companyOverseas = getIn(formikProps.values, 'companyOverseas');

    return (
    <div className='w-800px d-flex flex-column justify-content-start align-items-stretch'>
        <div className='pb-10 pb-lg-12'>
            <h2 className='fw-bolder text-dark'>Provide your Company Details</h2>            
        </div>

        <div className='fv-row row gy-5'>
            <div className="col-5 mt-8 text-end">
                <label className='form-label required'>Company Name</label>        
            </div>
            <div className="col mb-4">
                <Field name='companyName' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='companyName' />
                </div>
            </div>            
        </div>
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">            
            </div>
            <div className="col mb-4">
                <div className='d-flex align-items-center'>                    
                    <div className='form-check form-check-custom form-check-solid me-5'>
                        <Field name="companyOverseas" className='form-check-input' type='checkbox'  />
                    </div>                
                    <label htmlFor="companyOverseas">Overseas</label>                    
                </div>
            </div>
        </div>

        { (! companyOverseas) && 
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">            
                <label className='form-label required'>Company Registration</label>        
            </div>
            <div className="col mb-4">
                <Field name='companyRegistration' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='companyRegistration' />
                </div>
            </div>
        </div>
        }        
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">            
                <label className='form-label required'>Address</label>        
            </div>
            <div className="col mb-4">
                <Field name='companyAddress' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='companyAddress' />
                </div>
            </div>
        </div>
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">            
                <label className='form-label required'>Telephone</label>        
            </div>
            <div className="col mb-4">
                <Field name='companyTelephone' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='companyTelephone' />
                </div>
            </div>
        </div>
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">
                <label className='form-label'>Fax</label>        
            </div>
            <div className="col mb-4">                
                <Field name='companyFax' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='companyFax' />
                </div>
            </div>
        </div>
        <div className='fv-row row gy-5'>
            <div className="col-5 mt-7 text-end">
                <label className='form-label'>Website</label>        
            </div>
            <div className="col mb-4">
                <Field name='companyWebsite' className='form-control form-control-solid form-control-sm' />
                <div className='text-danger'>
                    <ErrorMessage name='companyWebsite' />
                </div>
            </div>
        </div>
    </div>
  )
}

export {Step1}
